// Temporary instrumentation for the in-call feature test on staging:
// every call-screen action logs which button was pressed and, for server actions,
// the exact payload and response. Grep the console for "🎛️".
export const logAction = (action, details) => {
  if (details === undefined) {
    console.log(`🎛️ ACTION: ${action}`)
    return
  }
  console.log(`🎛️ ACTION: ${action}`, details)
}

export const logResult = (action, response) => {
  const data = response?.data
  const error = response?.error
  if (error) {
    console.error(`🎛️ RESULT: ${action} FAILED`, error)
    return
  }
  console.log(`🎛️ RESULT: ${action}`, data)
}
